@use 'styles/variables';
@use 'styles/mixins';

.Container {
  height: 80vh;
}

.OuterModal {
  width: 75vw;
  max-width: unset;
}

.MultipleBtn {
  display: flex;

  flex-direction: row;

  position: relative;

  column-gap: 10px;

  margin-right: 10px;
}

.DownArrow {
  transform: rotate(270deg);
}

.UpArrow {
  transform: rotate(90deg);
}

@include mixins.forScreen(
  variables.$mobile-small-width,
  variables.$mobile-big-width - 1
) {
  .OuterModal {
    width: 100vw;
  }
}

@media (min-width: variables.$desktop-width) {
  .ModalWrap {
    > div {
      right: -5%;
    }
  }
}
